import { Checkbox } from './Checkbox';

export type { CheckboxProps } from './types';

export default Checkbox;
